<template>
    <div class="nqt--profile" ref="nqt--profile">
        <div class="box-ttct">
            <div class="card-avtar" :class="{pc: !mobile}">
                <div>
                    <img v-if="user.avatar == null && user.sex == 1" src="../../../static/images/profile.jpg" alt="Nam" class="avt-us" />
                    <img v-if="user.avatar == null && (user.sex == '' || user.sex == null)" src="../../../static/images/profile.jpg" alt="Nam" class="avt-us" />
                    <img v-else-if="user.avatar == null && user.sex == 2" src="../../../static/images/SA-ava-nu.png" alt="Nu" class="avt-us" />
                    <img v-else-if="user.avatar != null" :src="user.avatar" alt="Admin" class="avt-us" />
                </div>
                <div class="dispdi n-img" v-if="!mobile">
                    <span class="sex">
                        <img v-if="user.sex == 1" src="../../../static/images/nam.png" />
                        <img v-if="user.sex == 2" src="../../../static/images/nu.png" />
                    </span>
                    <span class="userName">
                        <template v-if="user.userName != null && user.userName.search('@') !== -1">{{user.userName.substring(0, user.userName.search('@'))}}</template>
                        <template v-if="user.userName != null && user.userName.search('@') == -1">{{user.userName}}</template>
                    </span>
                </div>
                <div class="dispdi" v-if="!mobile">
                    <span v-html="user.studentSynopsis"></span>
                </div>
                <div class="export_score_student" v-if="!mobile">
                    <button class="btn-download-tt" style="padding: 0px 13px;" @click="download()">
                        {{$t('manage_student.export')}}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                            <polyline points="7 10 12 15 17 10" />
                            <line x1="12" y1="15" x2="12" y2="3" />
                        </svg>
                    </button>
                </div>
                <div v-if="!mobile">
                    <button class="btn-download-tt" @click="downloadDiligent()">
                        {{$t('manage_student.exportDiligent')}}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                            <polyline points="7 10 12 15 17 10" />
                            <line x1="12" y1="15" x2="12" y2="3" />
                        </svg>
                    </button>
                </div>
            </div>
            <div class="card-tt" :class="{pc: !mobile}">
                <template v-if="mobile">
                    <div class="row-tt">
                        <label class="tt-n">{{$t('profile.name')}}</label>
                        <span>
                            <template v-if="user.userName != null && user.userName.search('@') !== -1">{{user.userName.substring(0, user.userName.search('@'))}}</template>
                            <template v-if="user.userName != null && user.userName.search('@') == -1">{{user.userName}}</template>
                        </span>
                    </div>
                    <div class="row-tt">
                        <label class="tt-n">{{$t('profile.sex')}}</label>
                        <span v-if="user.sex == 1">{{$t('manage_student.male')}}</span>
                        <span v-if="user.sex == 2">{{$t('manage_student.female')}}</span>
                    </div>
                </template>

                <!-- Download: waiting ticket -->
                <!-- <template v-if="!mobile">
                    <button class="btn-download-tt" @click="download()">
                        {{$t('manage_student.export')}}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-download">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                            <polyline points="7 10 12 15 17 10" />
                            <line x1="12" y1="15" x2="12" y2="3" />
                        </svg>
                    </button>
                </template> -->

                <div class="row-tt">
                    <label class="tt-n">{{$t('manage_student.age')}}</label>
                    <span>{{user.age}}</span>
                </div>
                <div class="row-tt">
                    <label class="tt-n">{{$t('profile.email')}}</label>
                    <span>{{user.email}}</span>
                </div>
                <div class="row-tt">
                    <label class="tt-n">{{$t('manage_student.job')}}</label>
                    <span>{{user.job}}</span>
                </div>
                <div class="row-tt">
                    <label class="tt-n">{{$t('manage_student.mobile')}}</label>
                    <span>{{user.mobile}}</span>
                </div>
                <div class="row-tt">
                    <label class="tt-n">{{$t('manage_student.level')}}</label>
                    <span>{{user.level}}</span>
                </div>
                <div class="row-tt">
                    <label class="tt-n">{{$t('manage_student.chi_nhanh')}}</label>
                    <span>{{user.deptNames}}</span>
                </div>
                <!-- click hiển thị thống kê -->
                <h4 class="h4-thongke showStaticals" v-if="!checkShowStatical" @click="showStatical()">{{$t('profile.showStatical')}} <span>&#128317;</span></h4>
                <h4 class="h4-thongke" v-else>{{$t('profile.statistic')}}</h4>
                <!-- Thống kê -->
                <template v-if="checkShowStatical">
                    <div class="row-tt">
                        <label>{{$t('profile.jonhLiveCourse')}}</label>
                        <span>{{ jonhCourseLive }}</span>
                    </div>
                    <div class="row-tt">
                        <label>{{$t('profile.noJonhLiveCourse')}}</label>
                        <span>{{ noJonhCourseLive }}</span>
                    </div>
                    <div class="row-tt" @click="jump(-1)">
                        <label :class="{csp: lesson_nbg + lesson_ln + lesson_end > 0}">{{$t('profile.sum_lesson')}}</label>
                        <span :class="{cs: lesson_nbg + lesson_ln + lesson_end > 0}">{{lesson_nbg + lesson_ln + lesson_end}} {{$t('profile.course')}}</span>
                    </div>
                    <div class="row-tt" @click="jump(0)">
                        <label :class="{csp: lesson_nbg > 0}">{{$t('profile.lesson_begin')}}</label>
                        <span :class="{cs: lesson_nbg > 0}">{{lesson_nbg}} {{$t('profile.course')}}</span>
                    </div>
                    <div class="row-tt" @click="jump(1)">
                        <label :class="{csp: lesson_ln > 0}">{{$t('profile.lesson_learning')}}</label>
                        <span :class="{cs: lesson_ln > 0}">{{lesson_ln}} {{$t('profile.course')}}</span>
                    </div>
                    <div class="row-tt" @click="jump(2)">
                        <label :class="{csp: lesson_end > 0}">{{$t('profile.lesson_end')}}</label>
                        <span :class="{cs: lesson_end > 0}">{{lesson_end}} {{$t('profile.course')}}</span>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex";

    export default {
        data() {
            return {
                user: null,
                lesson_nbg: 0,
                lesson_ln: 0,
                lesson_end: 0,
                checkShowStatical: false,
                jonhCourseLive: 0,
                noJonhCourseLive: 0,
            };
        },
        computed: {
            // Lấy dữ liệu từ store
            ...mapState({
                mobile: (state) => state.header.mobile
            }),
        },
        props: {
            data: {
                type: Object,
                default: {},
            },
        },
        created() {
            this.init();
        },
        methods: {
            init: function () {
                this.user = this.data.user;
                this.lesson_nbg = this.data.courses.filter((item) => parseInt(item.statusLesson) == 0).length;
                this.lesson_ln = this.data.courses.filter((item) => parseInt(item.statusLesson) == 1).length;
                this.lesson_end = this.data.courses.filter((item) => parseInt(item.statusLesson) == 2).length;
            },

            // Đến danh sách khóa học
            jump: function (type) {
                this.$emit("jump", type);
            },

            ...mapMutations("manageStudent", ["setLoadingStudent"]),

            // format date
            appendLeadingZeroes: function (n) {
                if (n <= 9) {
                    return "0" + n;
                }
                return n;
            },
            /// Click hiển thị thống kê
            showStatical: async function(){
                this.setLoadingStudent(true);
                const self = this;
                var getDataDiligent = await this.getDataDiligentStudents();
                getDataDiligent.forEach(value => {
                    if (value.studyDate==null) {
                        self.noJonhCourseLive+=1;
                    } else {
                        self.jonhCourseLive+=1;
                    }
                });
                self.checkShowStatical = true;
                self.setLoadingStudent(false);
            },
            /// Xuất chuyên cần học viên
            downloadDiligent: async function(){
                this.setLoadingStudent(true);
                const self = this;
                var getDataDiligent = await this.getDataDiligentStudents();
                if (getDataDiligent.length==0) {
                    self.setLoadingStudent(false);
                    self.$confirm(window.vm.$i18n.t("new.title114"),
                        window.vm.$i18n.t("new.title86"),
                        {cancelButtonClass: "btn-nqt---show"}
                    ).then(() => {}).catch(() => {});
                    return;
                }
                let checkNumberJonhLive = 0;
                let checkNumberNoJonhLive = 0;
                getDataDiligent.forEach(value => {
                    if (value.liveTeacher==null) {
                        value.liveTeacher = "_";
                    } else {
                        value.liveTeacher = value.liveTeacher.replace(/,/g, " |");
                    }
                    if (value.courseName==null) {
                        value.courseName = "_";
                    }
                    if (value.studyDate==null) {
                        value.studyDate = "_";
                        checkNumberNoJonhLive+=1;
                    } else {
                        checkNumberJonhLive+=1;
                    }
                    if (value.startDate==null) {
                        value.startDate = "_";
                    }
                    if (value.startTime==null) {
                        value.startTime = "_";
                    }
                    if (value.endTime==null) {
                        value.endTime = "_";
                    }
                });
                let fileName = self.user.userName + "_" + checkNumberJonhLive + "_" + checkNumberNoJonhLive + ".csv";
                self.setLoadingStudent(false);
                var headerName = [
                    {
                        key: "courseName",
                        value: "home.courseName",
                    },
                    {
                        key: "studyDate",
                        value: "profile.studyTime",
                    },
                    {
                        key: "startDate",
                        value: "home.teachingTime",
                    },
                    {
                        key: "startTime",
                        value: "studySituationList.validityPeriodStart",
                    },
                    {
                        key: "endTime",
                        value: "studySituationList.validityPeriodEnd",
                    },
                    {
                        key: "liveTeacher",
                        value: "manage_student.teacher",
                    },
                ];
                var params = {
                    header: true,
                    titles: ["courseName", "studyDate", "startDate", "startTime", "endTime", "liveTeacher"],
                    data: getDataDiligent,
                    headerName: headerName,
                    name: fileName
                };
                self.exportCsv(params);
            },
            /// Lấy danh sách khoá học online của học viên
            getDataDiligentStudents: function () {
                return new Promise((resolve, reject) => {
                    this.$api
                    .post("/courseStudy/getAllCourseOnlineByStudentId", {
                        studentId: this.user.id
                    })
                    .then((response) => {
                        resolve(response.data);
                    })
                    .catch((err) => {
                        reject(err.response);
                    });
                });
            },
            // Xuất thành tích học viên
            download: function () {
                const self = this;
                this.setLoadingStudent(true);

                let currentDatetime = new Date();
                let today = currentDatetime.getFullYear() + "/" + this.appendLeadingZeroes(currentDatetime.getMonth() + 1) + "/" + this.appendLeadingZeroes(currentDatetime.getDate());
                let fileName = this.data.user.userName + "_" + today + ".csv";

                let data = this.data.courses.filter(item => parseInt(item.status) != 0 && parseInt(item.status) != -1);

                Promise.all(data.map(item => {
                    return self.getsingleCourseScoreStatistics(item);
                })).then(function(results) {
                    
                    let statistics = results.filter(item => item.statistics.length > 0);

                    const listQ = statistics.reduce((a, v) => {
                        const students = v.statistics.reduce((s, sv) => {                    
                            let obj = {
                                examId: sv.examId,
                                courseId: v.courseId
                            }
                            s.push(obj);
                            return s;
                        }, []);
                        v.students = students;
                        a.push(v);
                        return a;
                    }, []);

                    const listS = listQ.reduce((a, v) => {
                        a = a.concat(v.students);
                        return a;
                    }, []);

                    Promise.all(listS.map(item => {
                        return self.getExamRecord(item);
                    })).then(function(results2) {
                        let examList = results2.filter(item => item.examList.length > 0);
                        const listE = examList.reduce((accumulator, value) => {
                            accumulator = accumulator.concat(value.examList);
                            return accumulator;
                        }, []);
                        
                        const csvPrev = listE.reduce((accumulator, value) => {

                            let passMark = parseFloat(value.res) ? parseFloat(value.res) : 0;
                            let score = parseFloat(value.score) ? parseFloat(value.score) : 0;
                            let status = score >= passMark ? self.$t("scoreStatistics.point90") : self.$t("scoreStatistics.point80");                  

                            value.courseName = value.courseName != null ? value.courseName.replace(/,/g, " |") : value.courseName;                   
                            value.deptNames = value.deptNames != null ? value.deptNames.replace(/,/g, " |") : value.deptNames;                   
                            value.examName = value.examType == 2 ? value.examName : self.$t("scoreStatistics.finalExam");
                            value.timeExamStart = value.timeExamStart != null ? value.timeExamStart : "ー";
                            value.timeExamEnd = value.timeExamEnd != null ? value.timeExamEnd : "ー";
                            value.timeExamConduct = parseInt(value.timeExamConduct) ? parseFloat(value.timeExamConduct) : 0;
                            value.fullMarks = parseFloat(value.fullMarks) ? parseFloat(value.fullMarks) : 0;
                            value['passMarks'] = parseFloat(value.res) ? parseFloat(value.res) : 0;
                            value['score'] = parseFloat(value.score) ? parseFloat(value.score) : 0;
                            value['status'] = status;
                            
                            accumulator.push(value);
                            return accumulator;
                        }, []);

                        const csv = csvPrev.filter(item => item.examName != null);

                        // Export
                        // Khai báo header CSV
                        var headerName = [
                            {
                                key: "studentName",
                                value: "profile.name",
                            },
                            {
                                key: "deptNames",
                                value: "manage_student.chi_nhanh",
                            },
                            {
                                key: "courseName",
                                value: "home.courseName",
                            },
                            {
                                key: "examName",
                                value: "scoreStatistics.testName",
                            },
                            {
                                key: "fullMarks",
                                value: "new.title24",
                            },
                            {
                                key: "passMarks",
                                value: "scoreStatistics.passPercent",
                            },
                            {
                                key: "score",
                                value: "examResume.point",
                            },
                            {
                                key: "status",
                                value: "scoreStatistics.judge",
                            },
                            {
                                key: "timeExamStart",
                                value: "scoreStaticNew.timeExamStart",
                            },
                            {
                                key: "timeExamEnd",
                                value: "scoreStaticNew.timeExamEnd",
                            },
                            {
                                key: "timeExamConduct",
                                value: "scoreStaticNew.timeExamConducted",
                            }
                        ];
                        var params = {
                            header: true,
                            titles: ["studentName", "deptNames", "courseName", "examName", "timeExamConduct", "timeExamStart", "timeExamEnd", "fullMarks", "passMarks", "score", "status"],
                            data: csv,
                            headerName: headerName,
                            name: fileName
                        };

                        // Download
                        self.setLoadingStudent(false);
                        if (csv.length) {
                            self.exportCsv(params);
                        } else {
                            self.$confirm(this.$i18n.t("new.title112"),
                                this.$i18n.t("new.title86"),
                                {cancelButtonClass: "btn-nqt---show"}
                            ).then(() => {}).catch(() => {});
                        }
                    })
                })
            },

            // Lấy lịch sử thi của học viên theo từng khóa
            getExamRecord: function (item) {
                let courseId = item.examId == null ? item.courseId : null;
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/home/getExamRecord", {
                            courseId: courseId,
                            examId: item.examId,
                            languageType: this.$lang(),
                            userId: this.user.id
                        })
                        .then((response) => {
                            const list = response.data.list.reduce((accumulator, value) => {
                                value['studentName'] = this.user.userName;
                                value['deptNames'] = this.user.deptNames;
                                value['courseId'] = courseId;
                                accumulator.push(value);
                                return accumulator;
                            }, []);

                            item['examList'] = list;
                            resolve(item);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Get examID
            getsingleCourseScoreStatistics: function (item) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/home/getsingleCourseScoreStatistics", {
                            courseId: item.courseId,
                            languageType: this.$lang(),
                            userId: this.user.id
                        })
                        .then((response) => {
                            item['statistics'] = response.data;
                            resolve(item);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Lấy điểm đậu
            getPastExamInfo: function (item) {
                let courseId = item.examId == null ? item.courseId : null;
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/studyCourseQuestion/getPastExamInfo", {
                            courseId: courseId,
                            examId: item.examId,
                        })
                        .then((response) => {
                            let passMarks = response.data.passMarks;
                            let status = Number(item.score) >= Number(passMarks) ? this.$t("scoreStatistics.point90") : this.$t("scoreStatistics.point80");
                            item['passMarks'] = passMarks;
                            item['status'] = status;
                            item['courseName'] = item.courseName.replace(/,/g, ' |');
                            resolve(item);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },
        },
    };
</script>
<style scoped>
    @media (max-width: 1112px) {
        .btn-download-tt {
            height: 83px!important;
        }
    }
    @media (max-width: 540px) {
        .btn-download-tt {
            height: 40px!important;
        }
    }
    .export_score_student{
        margin-top: 1vh;
    }
    .nqt-pst-a {
        position: absolute !important;
    }
    .nqt-pd-0 {
        padding-top: 0;
    }
    .nqt-col-8 {
        -ms-flex: 0 0 66.666667%;
        flex: 0 0 66.666667%;
        max-width: 66.666667%;
        padding-left: 10px;
    }
    .nqt-t-r {
        text-align: right;
    }
    .mb-2 {
        margin-bottom: 2rem;
        margin-top: 2rem;
    }
    .nqt-lesons-sum {
        margin-top: 10px;
        margin-left: 25px;
        font-size: large;
    }
    .nqt--row {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    .nqt-col-sm-3 {
        -ms-flex: 0 0 25%;
        flex: 0 0 25%;
        max-width: 25%;
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
    .nqt-col-sm-9 {
        -ms-flex: 0 0 75%;
        flex: 0 0 75%;
        max-width: 75%;
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        color: #6c757d !important;
    }
    .nqt-col-sm-5 {
        -ms-flex: 0 0 35%;
        flex: 0 0 35%;
        max-width: 35%;
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
    }
    .nqt-col-sm-7 {
        -ms-flex: 0 0 65%;
        flex: 0 0 65%;
        max-width: 65%;
        position: relative;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        color: #6c757d !important;
    }
    hr {
        margin-top: 1rem;
        margin-bottom: 1rem;
        border: 0;
        border-top: 1px solid rgba(0, 0, 0, 0.1);
    }
    hr {
        box-sizing: content-box;
        height: 0;
        overflow: visible;
    }
    .mb-3,
    .my-3 {
        margin-bottom: 1rem !important;
    }
    .nqt--profile {
        margin-top: 20px;
    }
    .nqt--mt1 {
        margin-top: 1rem !important;
    }
    .nqt--profile .card {
        position: relative;
        display: flex;
        flex-direction: column;
        min-width: 0;
        word-wrap: break-word;
        background-color: #fff;
        background-clip: border-box;
        border: 0 solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
        box-shadow: 0 1px 3px 0 rgb(0 0 0 / 80%), 0 1px 2px 0 rgb(0 0 0 / 80%);
    }
    .nqt--profile .nqt-col-4 {
        -ms-flex: 0 0 33.333333%;
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }
    .nqt--profile .card .card-body {
        flex: 1 1 auto;
        min-height: 1px;
        padding: 1rem;
    }
    .nqt--profile .card .card-body .card-content {
        text-align: center !important;
        align-items: center !important;
        -ms-flex-direction: column !important;
        flex-direction: column !important;
        display: -ms-flexbox !important;
        display: flex !important;
        text-align: center !important;
    }
    .nqt--profile .card .card-body .card-content .rounded-circle {
        border-radius: 50% !important;
        vertical-align: middle;
        border-style: none;
        width: 106px;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 {
        margin-top: 1rem !important;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 h4 {
        margin-bottom: 1rem !important;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 .text-secondary.mb-1 {
        margin-bottom: 1rem !important;
        color: #6c757d !important;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 .text-muted.font-size-sm {
        color: #6c757d !important;
        margin-bottom: 1rem !important;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 .btn.btn-primary {
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 .btn {
        display: inline-block;
        font-weight: 400;
        color: #212529;
        text-align: center;
        vertical-align: middle;
        cursor: pointer;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        background-color: transparent;
        border: 1px solid transparent;
        padding: 0.375rem 0.75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: 0.25rem;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }
    .nqt--profile .card .card-body .card-content .nqt-mt-3 .btn.btn-outline-primary {
        color: #007bff;
        border-color: #007bff;
    }
    .list-group {
        display: -ms-flexbox;
        display: flex;
        -ms-flex-direction: column;
        flex-direction: column;
        padding-left: 0;
        margin-bottom: 0;
    }
    .card > .list-group:first-child .list-group-item:first-child {
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
    }
    .list-group-flush .list-group-item:first-child {
        border-top-width: 0;
    }
    .list-group-flush .list-group-item {
        border-right-width: 0;
        border-left-width: 0;
        border-radius: 0;
    }
    .list-group-item:first-child {
        border-top-left-radius: 0.25rem;
        border-top-right-radius: 0.25rem;
    }
    .align-items-center {
        -ms-flex-align: center !important;
        align-items: center !important;
    }
    .justify-content-between {
        -ms-flex-pack: justify !important;
        justify-content: space-between !important;
    }
    .flex-wrap {
        -ms-flex-wrap: wrap !important;
        flex-wrap: wrap !important;
    }
    .d-flex {
        display: -ms-flexbox !important;
        display: flex !important;
    }
    .list-group-item {
        position: relative;
        display: block;
        padding: 0.75rem 1.25rem;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.125);
    }
    h6.mb-0 {
        margin-bottom: 0 !important;
        font-size: 1rem;
    }
    h6.mb-0 .text-secondary {
        color: #6c757d !important;
    }
    .mr-2,
    .mx-2 {
        margin-right: 0.5rem !important;
    }
    svg {
        overflow: hidden;
        vertical-align: middle;
    }
    .card-tt.pc .row-tt {
        border: none;
        padding: 0;
    }
    .card-tt.pc .row-tt label {
        padding: 4px 0;
        border-bottom: 1px #eceef5 solid;
        width: 240px;
        font-size: 14px;
        font-weight: bold;
    }
    .card-tt.pc .row-tt label.tt-n {
        width: 240px;
    }
    .card-tt.pc .row-tt span {
        padding: 4px 0;
        width: calc(100% - 240px);
        border-bottom: 1px #eceef5 solid;
        text-align: right;
    }
    .tt-icon {
        width: 24px;
        height: 24px;
        margin: 5px 5px 5px 0;
    }
    .csp {
        cursor: pointer;
    }
    .cs {
        cursor: pointer;
        color: rgb(0 0 205);
    }
    .h4-thongke {
        font-size: 13px;
        background: #00b5ad;
        margin: 10px 0;
        padding: 5px 10px;
        color: #fff;
    }
    .card-avtar.pc {
        width: 340px;
    }
    .card-tt.pc {
        width: calc(100% - 340px);
        padding-left: 10px;
    }
    .dispdi {
        margin-top: 5px;
        color: #9b9c98;
        text-align: center;
    }
    .userName {
        text-transform: uppercase;
        font-size: 18px;
        font-weight: 700;
        color: #0071c5;
        margin-left: 10px;
    }
    .n-img {
        display: flex;
    }
    .n-img img {
        width: 17px;
    }
    .showStaticals {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/manage/profile.vue